import { openRegisterLink } from '@/utils/trackRegisterClick';

export default function CasinoReviewSection() {
  const casinoReviews = [
    {
      rank: 1,
      name: 'IPAY9VIP',
      subtitle: 'VIP-Focused iPay9 Experience with Premium Benefits',
      image: '/casinoBrand/ipay9vip.jpeg',
      casinoName: 'IPAY9VIP Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA)',
      url:'https://www.ipay9aud.co/en-au/?ref=IPAY9C9C43',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Pokies Bonus 100% + Register Free $10',

      review: {
        intro:
          'IPAY9VIP is the VIP-focused extension of iPay9, tailored for players who want extra member perks, smoother gameplay performance, and an upgraded overall casino experience. The platform emphasizes low-lag sessions, stable access to games, and a premium account environment for Australian users.',

        bonusGames:
          'New users are welcomed with Pokies Bonus 100% + Register Free $10, combining quick signup value with a strong pokies-first reward structure. IPAY9VIP supports a broad mix of popular slot content and recurring promotional events designed for higher engagement players.',

        security:
          'IPAY9VIP places strong focus on payment safety and account protection through encrypted transaction channels, verification controls, and secure platform operations. Responsible gaming features are included to support safer and more controlled long-term play.',

        payments:
          'Deposits and withdrawals are structured for clarity and consistency, with familiar options available to Australian players. The minimum deposit starts from A$10, and the payment flow is optimized to reduce friction for both new and returning VIP users.'
      }
    },
    {
      rank: 2,
      name: 'MRBOOM9',
      subtitle: 'Designed for Popular Games & Ongoing Rewards',
      image: '/casinoBrand/mrboom9.jpg',
      casinoName: 'MRBOOM9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA)',
      url:'https://mrboom9.com/RFPPOKINOMICS',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Register Free $99.99 + Apps Daily $20',

      review: {
        intro:
          'MrBoom9 is a strong option for Australian players who want headline bonus value without sacrificing performance. The advertised Register Free $99.99 + Apps Daily $20 gives newcomers an immediate, friendly starting boost while sessions stay smooth—minimal lag, sharper HD presentation on supported titles, and a steady stream of new games alongside familiar favourites.',

        bonusGames:
          'Register Free $99.99 + Apps Daily $20 is the standout sign-up hook, pairing quick account credit with ongoing perks that respect smaller bankrolls. Promotions complement a growing catalogue that prioritises fresh releases from trusted studios, plus classic pokies and live tables for players who want variety without hunting across multiple sites.',

        security:
          'MrBoom9 operates under recognised offshore oversight (Curacao Gaming Authority (CGA) with Pagcor-aligned standards where applicable). SSL encryption, identity checks on withdrawals, and standard responsible-gaming controls help keep accounts and gameplay within safer boundaries.',

        payments:
          'Australian players can fund and cash out through trusted options such as Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay—chosen to balance convenience with stronger protection than ad-hoc transfer methods. Deposits are usually instant; withdrawal timing follows normal verification and method-specific processing.'
      }
    },
    {
      rank: 3,
      name: 'IPAY9',
      subtitle: 'Popular E-Wallet Casino Among Australian Players',
      image: '/casinoBrand/ipay9.jpeg',
      casinoName: 'IPAY9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ)',
      url:'https://i9aud.net/RFPOKINOMICS1',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Monthly Deposit Ranking $1999',

      review: {
        intro:
          'IPAY9 is recognised as one of Australia’s top online casino choices of the year, offering a polished user experience, fast loading performance, and a strong selection of high-quality pokies and live dealer games. Its stability and consistent user satisfaction make it a standout platform for players seeking a trusted and well-rounded real-money casino environment.',

        bonusGames:
          'IPAY9 welcomes new players with Monthly Deposit Ranking $1999 as the headline offer. The casino features a wide mix of classic and modern pokies, jackpot titles, and live table games, supported by reputable providers. Regular events, reload bonuses, and cashback rewards offer extra value to active players.',

        security:
          'IPAY9 operates under Curacao Gaming Authority (CGA) and Pagcor oversight, ensuring verified fairness and secure gaming conditions. The platform uses SSL data encryption, strict account-verification processes, and responsible gaming tools including deposit limits and cooling-off options.',

        payments:
          'IPAY9 supports Australia-friendly banking options including Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant, and withdrawals are typically processed within 24–48 hours depending on the method. Minimum deposit starts from A$10, making it accessible for most players.'
      }
    },
    {
      rank: 4,
      name: 'KINGBET9',
      subtitle: 'Pokies-Focused Casino with Generous Bonus Offers',
      image: '/casinoBrand/kingbet9.jpeg',
      casinoName: 'KINGBET9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ)',
      url:'https://kingbett9.com/RFPOKINOMICS13',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Slot Daily Bns 39% + Missions Get $100',

      review: {
        intro:
          'KINGBET9 has become a favourite among Australian slot enthusiasts thanks to its premium pokies library, smooth gameplay, and refined interface. Positioned as a paradise for pokies lovers, the platform provides a superior real-money experience with high-quality game design and reliable performance across all devices.',

        bonusGames:
          'New members can access Slot Daily Bns 39% + Missions Get $100 as the core bonus value, with boosted daily rewards and extra playtime across hundreds of high-quality pokies. KINGBET9 regularly refreshes its promotional calendar with reload bonuses, share bonuses, and milestone rewards tailored to active users.',

        security:
          'The site is licensed under Pagcor and Curacao Gaming Authority (CGA), ensuring safe, regulated play. KINGBET9 uses encrypted banking channels, strict identity verification, and automated fairness checks on all games. Players also have access to deposit limits, timeout tools, and responsible gaming guidelines.',

        payments:
          'KINGBET9 supports fast and secure banking for Australian users through Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant, while withdrawals are typically processed within 24–48 hours depending on verification. Minimum deposit begins at A$10.'
      }
    },
    {
      rank: 5,
      name: 'BIGPAY77',
      subtitle: 'Promotion-Driven Casino with Frequent Player Rewards',
      image: '/casinoBrand/bp77.jpeg',
      casinoName: 'BIGPAY77 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 365/JAZ)',
      url:'https://bigpay77.co/RFBPOKINOMICS',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: '80% Welcome Bonus + 7% Weekly Rebate',

      review: {
        intro:
          'BIGPAY77 provides a vibrant, feature-rich gaming platform designed for players who appreciate frequent promotions, fast payouts, and an energetic casino atmosphere. Its balance of high-quality pokies and live dealer content makes it a reliable choice for Australians seeking variety and rewarding gameplay.',

        bonusGames:
          'New players can unlock up to 80% welcome bonus plus 7% weekly rebate as the core sign-up structure, alongside rotating daily boosts. The game library includes top-tier pokies, jackpot titles, and HD live dealer rooms. BIGPAY77 frequently releases themed promotions and leaderboard challenges with attractive prize pools.',

        security:
          'The casino operates under a valid Curacao licence and adheres to strict player protection standards. Data encryption, secure payment gateways, and verified game providers ensure a safe and fair gaming environment. BIGPAY77 also offers responsible gaming controls for safer play.',

        payments:
          'Payment support includes Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant, while withdrawals are typically completed within 12–36 hours, faster than many competitors. Minimum deposit starts from A$10.'
      }
    },
    {
      rank: 6,
      name: 'ME99',
      subtitle: "Licensed Casino with Strong Player Protection Standards",
      image: '/casinoBrand/me99.jpeg',
      casinoName: 'ME99 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA)',
      url:'https://me99aus.net/RFPOKINOMICSME',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'JILI Welcome Bns 80% + $1999 Deposit Ranking',

      review: {
        intro:
          'ME99 attracts players seeking a regulated and transparent online casino experience backed by internationally recognised licensing standards. Its clean design, extensive pokies catalogue, and smooth navigation make it a trusted destination for Australians who prioritise legitimacy and high operational standards.',

        bonusGames:
          'New users can claim JILI Welcome Bns 80% + $1999 Deposit Ranking as the headline welcome value. ME99 features hundreds of classic and modern pokies, jackpot games, and themed slots, ensuring broad variety for all playstyles.',
        
        security:
          'Licensed by Curacao Gaming Authority (CGA), ME99 follows strict operational and fairness standards. Player data is protected using SSL encryption, while responsible gaming tools, including deposit limits and cool-off periods, are readily accessible.',
        
        payments:
          'Australian players can deposit using Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits clear instantly, and withdrawals usually process within 24–48 hours. Minimum deposit is A$10, making it beginner-friendly.'
      }
    },
    {
      rank: 7,
      name: 'GUCCI9',
      subtitle: 'VIP-Friendly Casino for High-Value and Premium Players',
      image: '/casinoBrand/gucci9.jpeg',
      casinoName: 'GUCCI9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 1668/JAZ)',
      url:'https://gucci9au.org/RFPOKINOMICSG',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Deposit Bonus 50% + Slot Daily Bonus 20%',

      review: {
        intro:
          'GUCCI9 delivers an elevated, luxury-inspired experience tailored for high-stakes and VIP-focused players. With premium visual design and a curated mix of pokies and live tables, the platform appeals to Australians who value exclusivity, refinement, and a polished online casino atmosphere.',

        bonusGames:
          'New members benefit from deposit bonus 50% plus slot daily bonus 20%, alongside VIP reward tiers with enhanced cashback, reload offers, and priority events. The platform highlights premium pokies, exclusive jackpots, and a dedicated high-stakes live dealer lobby.',

        security:
          'GUCCI9 operates under Curacao licensing and uses bank-grade encryption to secure transactions and account data. VIP accounts receive enhanced verification support, faster withdrawals, and dedicated service. Responsible gaming features are available for all players.',

        payments:
          'Supported methods include Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. High-limit players benefit from increased deposit limits and priority cashouts, typically processed within 12–24 hours.'
      }
    },
    {
      rank: 8,
      name: 'BYBID9',
      subtitle: 'Modern Casino Platform with Interactive Game Features',
      image: '/casinoBrand/bybid9.jpeg',
      casinoName: 'BYBID9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ)',
      url:'https://bybid9.net/RFPOKINOMICS',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Upto $130 Share Bns + Daily Missions $100',

      review: {
        intro:
          'BYBID9 brings a modern, innovation-driven approach to online gaming, featuring clean UI design, interactive elements, and efficient system performance. The platform suits Australian players who enjoy a futuristic casino experience with gamified features and visually appealing gameplay.',

        bonusGames:
          'BYBID9 promotes deposit $100 to win up to $1088 jackpot style offers, giving players high-value jackpot momentum alongside regular themed bonuses. The platform features a strong lineup of pokies with fast loading speeds, clean animations, and ongoing promotions.',

        security:
          'The platform operates under Curacao licensing and uses encrypted transaction channels, identity verification, and automated fairness auditing for all games. BYBID9 enforces responsible gaming policies and provides easy tools for setting play limits.',

        payments:
          'Australian players can deposit with Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits process instantly, while withdrawals typically complete within 24–48 hours. Minimum deposit is A$10.'
      }
    },
    {
      rank: 9,
      name: 'ROLEX9',
      subtitle: 'Reward-Focused Casino with Regular Bonus Campaigns',
      image: '/casinoBrand/rolex9.jpeg',
      casinoName: 'ROLEX9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ)',
      url:'https://rolex9au.com/RFPOKINOMICSS',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Register Free Credit A$99.99 + Daily Free $20',

      review: {
        intro:
          'ROLEX9 positions itself as a premium casino brand infused with luxury aesthetics and strong user experience design. Australian players appreciate its smooth interface, steady performance, and refined presentation that supports a professional, high-quality gaming environment.',

        bonusGames:
          'New users receive register free credit A$99.99 plus daily free $20 as the advertised package. ROLEX9 offers exclusive bonus wheels, cashback days, and themed event promotions that reward active players across both pokies and live table games.',

        security:
          'ROLEX9 uses secure encryption, responsible gaming protocols, and licensed software providers to maintain safe play. Its customer service team is responsive, helping players through verification, deposits, and responsible gaming settings.',

        payments:
          'Accepted banking methods include Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Withdrawals are usually completed within 24–48 hours after identity confirmation.'
      }
    },
    {
      rank: 10,
      name: 'WINNIE777',
      subtitle: 'Easy-to-Use Casino Designed for Regular Players',
      image: '/casinoBrand/winnie777.jpeg',
      casinoName: 'WINNIE777 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 1668/JAZ)',
      url:'https://winnie777.net/RFPOKINOMICSWI',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Up to $194 Share Bonus + Random Daily Free ?',

      review: {
        intro:
          'WINNIE777 offers a charming and approachable casino experience built around consistent rewards and easy navigation. Its friendly design and stable platform make it a reliable choice for regular Australian players who enjoy simple, enjoyable pokies and a relaxed gaming atmosphere.',

        bonusGames:
          'Players are greeted with up to $194 share bonus plus random daily free rewards—ideal for exploring Winnie-themed pokies and jackpot games. Seasonal events and share-based missions allow players to earn extra credit quickly.',

        security:
          'WINNIE777 operates with licensed providers and encrypted banking channels to maintain fairness and safety. The site includes responsible gaming tools such as session timers, deposit caps, and cool-off options.',

        payments:
          'WINNIE777 supports Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant and withdrawals generally take 24–48 hours after review.'
      }
    },
    {
      rank: 11,
      name: 'MICKY9',
      subtitle: 'Bonus-Oriented Casino with Daily Free Reward Options',
      image: '/casinoBrand/micky9.jpeg',
      casinoName: 'MICKY9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 365/JAZ)',
      url:'https://micky9.net/RFPOKINOMICSMI',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Free Credit $103.33 + Free Share Bns',

      review: {
        intro:
          'MICKY9 stands out with its playful theme and engaging design, attracting Australian players who enjoy a lighthearted yet reliable casino environment. Its strong focus on recurring rewards and smooth gameplay makes it especially appealing to players who enjoy frequent, casual entertainment.',

        bonusGames:
          'The headline offer centres on Free Credit $103.33 + Free Share Bns, rewarding qualifying deposits with tiered value. MICKY9 features themed pokies, high-volatility slots, and a stable selection of live table rooms for blackjack and roulette.',

        security:
          'The casino runs on a licensed engine with secure encryption and automated fairness verification. MICKY9 also provides responsible gaming support, including limit-setting and self-exclusion tools.',

        payments:
          'Supported deposit options include Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Withdrawals are fast for verified players, typically within one day.'
      }
    },
    {
      rank: 12,
      name: 'MRBEAN9',
      subtitle: 'Creative Casino Platform with Unique Game Experiences',
      image: '/casinoBrand/mrbean9.jpeg',
      casinoName: 'MRBEAN9 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 8048/JAZ)',
      url:'https://mrbean9au.com/RFPOKINOMICSM',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Special Welcome Bonus 200% + Daily Free $15',

      review: {
        intro:
          'MRBEAN9 differentiates itself through creative themes and innovative game flow, offering Australian players a refreshing alternative to traditional casino aesthetics. It is well-optimised for mobile use and appeals to users looking for quirky design, dynamic gameplay, and a unique casino identity.',

        bonusGames:
          'MRBEAN9 leads with special welcome bonus 200% plus daily free $15 for sustained early value. The platform offers unique promotional campaigns, mystery bonuses, jackpot drops, and a curated list of high-volatility pokies for thrill-seekers.',

        security:
          'MRBEAN9 uses encrypted banking, KYC verification, and licensed gaming providers to maintain fairness and security. Responsible gaming guidance and player protections are available throughout the platform.',

        payments:
          'Payment options include Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant, and withdrawals usually settle within 24–48 hours.'
      }
    },
    {
      rank: 13,
      name: 'QUEEN13',
      subtitle: 'High-Value Casino with Ongoing Daily Bonus Rewards',
      image: '/casinoBrand/queen13.jpeg',
      casinoName: 'QUEEN13 Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 1668/JAZ)',
      url:'https://queen13au.com/RFPOKINOMICSQU',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'New Register Free $113 + Daily Free $5',

      review: {
        intro:
          'QUEEN13 delivers a polished, luxury-inspired gaming atmosphere tailored for players who enjoy elegant design and high-value reward structures. Its refined interface, premium pokies, and smooth experience make it a strong choice for Australians looking for a sophisticated online casino environment.',

        bonusGames:
          'QUEEN13 promotes new register free $113 plus daily free $5 as the core recurring reward structure. The casino includes high-end pokies, jackpot titles, and well-designed live table rooms for roulette, blackjack, and baccarat.',

        security:
          'QUEEN13 maintains robust security with SSL encryption, identity verification, and fairness auditing through licensed providers. The casino also emphasizes responsible gaming, allowing players to set limits or activate self-managed controls at any time.',

        payments:
          'Supported banking options include Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits are instant, and withdrawals are typically processed within 24–48 hours once verification is completed.'
      }
    },
    {
      rank: 14,
      name: 'Spinaroo',
      subtitle: 'Gamified Casino Experience with Fast-Paced Gameplay',
      image: '/casinoBrand/spinaroo.jpeg',
      casinoName: 'Spinaroo Casino',
      license: 'Pagcor & Curacao Gaming Authority (CGA) (Licence No. 1668/JAZ)',
      url:'https://spinarooaus.com/RFPOKINOMICSP',

      liveTable: 'Yes',
      pokies: 'Yes',

      welcomeBonus: 'Daily Slot Bns 80% + Daily Bns $100',

      review: {
        intro:
          'Spinaroo introduces a colourful, next-generation casino concept featuring gamified mechanics and fast-paced navigation. Popular among younger Australian players, the platform blends adventure-style themes with responsive performance for a fun and modern gaming experience.',

        bonusGames:
          'Spinaroo highlights daily slot bns 80% and daily bns $100 opportunities for competitive rewards. The platform offers themed pokies, jackpot adventures, and exclusive game missions that reward consistent play. Its live table selection includes roulette, blackjack, and game-show style rooms.',

        security:
          'The casino uses trusted licensed providers and secure, audited RNG systems to ensure fairness. Player accounts are safeguarded with encrypted communication and mandatory verification steps for withdrawals.',

        payments:
          'Spinaroo accepts Visa, Mastercard, Apple Pay, Google Pay, Amopay, Osko, PayID, and Speedpay. Deposits clear instantly, and most withdrawals are approved within 24–48 hours after standard identity checks.'
      }
    },];

  const sortedCasinos = [...casinoReviews].sort((a, b) => a.rank - b.rank);

  return (
    <section id="top-list" className="py-8 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-0">
        {/* Section Title */}
        <h1 className="text-xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
          Reputable Online E-Wallet Casinos for Australian Players
        </h1>
        
        {/* Intro Paragraph */}
        <div className="mb-10">
          <p className="text-base md:text-md text-gray-700 leading-relaxed">
            Our expert review team has conducted comprehensive evaluations of Australia leading online casinos to bring you this authoritative guide. Each casino listed below has been rigorously tested across multiple criteria including licensing and regulation, game variety and quality, bonus terms and fairness, payment processing speed and reliability, customer support responsiveness, mobile compatibility, and overall user experience. We prioritize player safety, security, and satisfaction above all else, ensuring that every recommended casino meets or exceeds industry standards. Whether you're a seasoned player or new to online gambling, this detailed review will help you make an informed decision about where to play with confidence.
          </p>
        </div>

        {/* Casino Review Blocks */}
        <div className="space-y-8">
          {sortedCasinos.map((casino) => (
            <article key={casino.rank} className="border-b border-gray-200 pb-8 last:border-b-0 last:pb-0">
              {/* Ranking + Brand Name */}
              <h2 className="text-lg md:text-3xl font-bold text-gray-900 mb-6">
                {casino.rank}. {casino.name} – {casino.subtitle}
              </h2>

              {/* Feature Image */}
              <div className="mb-6 rounded-lg overflow-hidden shadow-md">
                <div className="w-full h-32 md:h-96">
                  <img 
                    src={casino.image} 
                    alt={`${casino.name} casino website screenshot`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* CTA Button */}
              <div className="mb-8">
                <button 
                  onClick={() => openRegisterLink({
                    section: 'casino_review_section',
                    brandName: casino.name,
                    url: casino.url,
                  })}
                  className="
                    w-full
                    bg-[#dc2626] hover:bg-[#b91c1c]
                    text-white 
                    font-bold whitespace-nowrap transition-colors cursor-pointer shadow-lg
                    px-8 py-3 text-base
                    md:px-12 md:py-4 md:text-lg
                    rounded-full
                  "
                >
                  Play Now at {casino.name}
                </button>
              </div>


              {/* Feature Table */}
              <div className="mb-8 overflow-hidden rounded-lg border border-gray-200 shadow-sm">
                <table className="w-full">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 md:px-6 py-4 bg-gray-50 font-semibold text-gray-900 text-sm md:text-base w-1/3">
                        Australian Casino Name
                      </td>
                      <td className="px-4 md:px-6 py-4 bg-white text-gray-700 text-sm md:text-base">
                        {casino.casinoName}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 md:px-6 py-4 bg-gray-50 font-semibold text-gray-900 text-sm md:text-base">
                        Gaming License
                      </td>
                      <td className="px-4 md:px-6 py-4 bg-white text-gray-700 text-sm md:text-base">
                        {casino.license}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 md:px-6 py-4 bg-gray-50 font-semibold text-gray-900 text-sm md:text-base">
                        Live Table
                      </td>
                      <td className="px-4 md:px-6 py-4 bg-white text-gray-700 text-sm md:text-base">
                        {casino.liveTable}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 md:px-6 py-4 bg-gray-50 font-semibold text-gray-900 text-sm md:text-base">
                        Pokies
                      </td>
                      <td className="px-4 md:px-6 py-4 bg-white text-gray-700 text-sm md:text-base">
                        {casino.pokies}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 md:px-6 py-4 bg-gray-50 font-semibold text-gray-900 text-sm md:text-base">
                        Welcome Bonus
                      </td>
                      <td className="px-4 md:px-6 py-4 bg-white text-gray-700 text-sm md:text-base font-medium">
                        {casino.welcomeBonus}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Detailed Review Paragraphs */}
              <div className="space-y-5 text-gray-700 leading-relaxed">
                <p className="text-base md:text-md">
                  {casino.review.intro}
                </p>
                <p className="text-base md:text-md">
                  {casino.review.bonusGames}
                </p>
                <p className="text-base md:text-md">
                  {casino.review.security}
                </p>
                <p className="text-base md:text-md">
                  {casino.review.payments}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
